import {ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {ActionsSubject, select, Store} from '@ngrx/store';
import {ActivatedRoute} from '@angular/router';
import * as fromRoot from '../../../shared/reducers';
import * as _ from 'lodash';
import {FormArray, FormGroup, Validators} from '@angular/forms';
import {GetFormsService} from '../../../shared/services/get-forms.service';
import * as fromOrder from '../../reducers';
import {OrderAddComponent} from '../../components/order-add/order-add.component';
import {ClearTimezonesSuccessAction, Client, Culture, LoadCurrentClientAction, Role, SEPARATOR_SELECT, Timezone} from '../../../shared';
import {Order} from '../../models/order';
import {debounceTime, distinctUntilChanged, filter, skipWhile} from 'rxjs/operators';
import {OrderMapperService} from '../../services/order-mapper.service';
import {LoadOrderAction, OrderClearAction} from '../../actions/order-load';
import {ValidatedAddressDHLAction} from '../../actions/dhl-validation-address';
import {DhlMapperService} from '../../services/get-config-dhl-validation.service';
import {DHLService} from '../../services/dhl-validation.service';
import {FooterDetails} from '../../models/footer-extra-info';
import * as moment from 'moment';
import {AddOrdersAction} from '../../actions/order-add';
import {LoadMyOrdersAction} from '../../../shared/actions/my-orders';
import {UpdateBreadOrderDetailsAction} from '../../actions/update-breadcrumb-order-details';
import {ServerForm} from '../../../shared/models/servers';
import {OrderForm} from '../../models/order-form';
import {LoadExchangeAction} from '../../actions/order-exchange';
import {UpdateDynamicFormService} from '../../../shared/services/update-dynamic-form.service';
import {ValidatedAddressShippingDHLAction} from '../../actions/dhl-validation-address-shipping';
import {CancelOrderComponent} from '../../components/cancel-order/cancel-order.component';
import {LoadOrdersFailAction} from '../../actions/order-list';
import {Location} from '@angular/common';
import {LoadProductsCompleteListAction, LoadProductsCompleteListClearAction} from '../../../shared/actions/product-complete-list';
import {LoadProductsAction} from '../../../shared/actions/product';
import {HeaderTitleAction} from '../../../shared/actions/header-title';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {ResetOrderModalComponent} from '../../components/reset-order-modal/reset-order-modal.component';
import {ClearServerAction, LoadServerByTypeAction} from '../../../shared/actions/servers';
import {LoadMySitesAction} from '../../../shared/actions/my-sites';
import * as fromShipping from '../../../shipping/reducers';
import {AddressSummaries} from '../../../shared/models/address';
import {SiteSummary} from '../../../shipping/models/shipping';
import {LoadSiteFullSummariesAction, LoadSiteSummariesClearAction} from '../../../shipping/actions/site-summaries';
import * as fromShared from '../../../shared/reducers';
import {LoadConceptsAction} from '../../../shared/actions/concept';
import {LoadConceptOrderAction, LoadConceptOrderClearAction} from '../../actions/order-dxp-concept-load';
import {Concept, ConceptOrder} from '../../../shared/models/concept';
import {Product} from '../../../shared/models/product';
import {LoadProductionLineWithParamsAction} from '../../../shared/actions/production-line';
import {ProductionLine} from '../../../shared/models/production-line';
import {LoadTimezoneFullCultureAction} from '../../actions/correlation-timezone-culture3';

@Component({
  selector: 'storever-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent implements OnInit, OnDestroy {

  form: FormGroup;
  dhlResult: FooterDetails[];
  dhlValidation: boolean;
  order$: Observable<Order>;
  timezone$: Observable<Timezone[]>;
  concepts$: Observable<ConceptOrder[]>;
  cultures$: Observable<Culture[]>;
  product$: Observable<Product[]>;
  productionLine$: Observable<ProductionLine[]>;
  addressSummaries$: Observable<SiteSummary>;
  timeZoneList: Timezone[];
  roles$: Observable<Role[]>;
  isInternalUser = false;
  cultureList: Culture[];
  orderForm: OrderForm;
  private timezoneObservable: Subscription;
  private cultureObservable: Subscription;
  private sub$: Subscription;
  private subscriptions = [];
  isLoading: boolean;
  @ViewChildren('childComponents') viewChildren: QueryList<OrderAddComponent>;
  @ViewChild('cancelOrder', {static: false}) cancelOrder: CancelOrderComponent;
  @ViewChild('resetOrder', {static: true}) resetOrder: ResetOrderModalComponent;
  orderIsDeleted: string;

  get title(): string {
    return this.activatedRoute.snapshot.routeConfig.data.title;
  }

  get isEdit(): boolean {
    return this.activatedRoute.snapshot.routeConfig.path === 'detail/:id'
  }

  get isExchange(): boolean {
    return this.activatedRoute.snapshot.routeConfig.path === 'add/:id'
  }
  get isAddSite(): boolean {
    return this.activatedRoute.snapshot.routeConfig.path === 'add/site/:siteUuid'
  }

  get isAdd(): boolean {
    return this.activatedRoute.snapshot.routeConfig.path === 'add'
  }

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private activatedRoute: ActivatedRoute,
              private formService: GetFormsService,
              private store: Store<fromOrder.AppState>,
              private storeShipping: Store<fromShipping.AppState>,
              private storeRoot: Store<fromRoot.AppState>,
              private dhlMapperService: DhlMapperService,
              private dhlService: DHLService,
              private orderMapper: OrderMapperService,
              private dispatcher: ActionsSubject,
              private location: Location,
              private cdr: ChangeDetectorRef,
              private updateDynamicFormService: UpdateDynamicFormService) {
    this.store.dispatch(new OrderClearAction()); // TODO: mettre dans effect ? // TODO: encore utile ?
    this.timezone$ = this.store.pipe(select(fromRoot.selectors.getTimezones));
    this.cultures$ = this.store.pipe(select(fromRoot.selectors.getCultures));
    this.product$ = this.store.pipe(select(fromRoot.selectors.getProducts));
    this.roles$ = this.store.pipe(select(fromShared.selectors.getMyRoles));

    this.addressSummaries$ = this.storeShipping.pipe(select(fromShipping.selectors.getSiteSummaries));
    this.productionLine$ = this.storeRoot.pipe(select(fromRoot.selectors.getProductionLine));
    this.dhlValidation = null;
    this.dhlServiceResponse();
    this.store.dispatch(new LoadConceptOrderClearAction());

  }

  ngOnInit(): void {
    this.isLoading = !this.isAdd; // helped to show loading in add order forms
    window.scroll(0, 0);
    this.form = this.formService.getOrder();


    this.mapOrder();
    this.dispatchLoadData();
    this.loadServer();
    this.bindClient();
    this.setValueChangesForm();
    this.updateAfterCountryChange();
    this.clearDhlMessage();
    if (this.isAdd || this.isAddSite) {
      this.disableShippingAddressIfSiteSame();
    }
    this.mapConcepts();
  }

  ngOnDestroy(): void {
    this.form.get('addresses').reset();
    this.form.get('contact').reset();
    this.clearDhlMessage();
    this.updateDynamicFormService.clear();
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
    this.storeRoot.dispatch(new LoadProductsCompleteListClearAction());
    this.storeRoot.dispatch(new LoadProductsAction());
    this.storeRoot.dispatch(new ClearServerAction());
    this.store.dispatch(new LoadConceptOrderClearAction());
    this.store.dispatch(new LoadSiteSummariesClearAction());
    this.form.get(['subscription', 'base', 'serverForm' , 'url', 'id']).clearValidators();
   // this.form.get(['subscription', 'base', 'serverForm' , 'server', 'id']).clearValidators();
    this.form.get(['subscription', 'base', 'serverForm' , 'cms', 'id']).clearValidators();
    this.form.get(['subscription', 'base', 'serverForm' , 'url',  'id']).updateValueAndValidity();
   // this.form.get(['subscription', 'base', 'serverForm' , 'server', 'id']).updateValueAndValidity();
    this.form.get(['subscription', 'base', 'serverForm' , 'cms', 'id']).updateValueAndValidity();
  }

  dispatchLoadData(): void {
    if (this.isExchange) {
      const  icon = 'fal fa-exchange fa-lg';
      this.storeRoot.dispatch(new HeaderTitleAction({icon: icon, title: '  Exchange '}));
      this.storeRoot.dispatch(new LoadProductsCompleteListAction());
      this.store.dispatch(new LoadExchangeAction(this.activatedRoute.snapshot.paramMap.get('id')));
    } else if (this.isEdit) {
      this.storeRoot.dispatch(new LoadProductsCompleteListAction());
      this.store.dispatch(new LoadOrderAction(this.activatedRoute.snapshot.paramMap.get('id')));
      this.sub$ = this.dispatcher.pipe(
        filter(action => action.type === '[order] Load Fail Gone'),
      ).subscribe((data: LoadOrdersFailAction) => {
        this.orderIsDeleted = data.payload;
      });
      this.subscriptions.push(this.sub$);
    }
    else if (this.isAdd || this.isAddSite) {
      const  icon = 'fa-shopping-cart far';
      this.storeRoot.dispatch(new HeaderTitleAction({icon: icon, title: '  Order creation '}));
      this.storeRoot.dispatch(new LoadProductsAction());
    }

  }

  dhlServiceResponse(): void {
    this.sub$ = this.dhlService.getResponse().subscribe((message) => {
      this.dhlValidation = null;
      if (this.form) {
        if (message) {
          this.dhlMapperService.DBToVue(message);
          if (this.dhlMapperService.getDhlDeliveryDate()) {
            this.updateFormDhlMessage(false, 'dispatch');
            this.dhlValidation = true;

            // TODO: Transformer la verification adresse chez DHL en service
            if (this.dhlMapperService.getDhlAddressType() === 'Site') {
              this.updateFormDhlMessage(false, 'Site');
              this.dhlResult[0] = {
                icon: 'fa fa-check',
                color: 'green',
                message: (this.dhlResult[1] && this.dhlResult[1].color !== 'red') ? 'DHL_VALIDATION_OK_WITHOUT_DATE' : 'DHL_VALIDATION_OK_SITE',
                extraData: (
                  this.dhlResult[1] && this.dhlResult[1].color !== 'red') ? null :
                  moment(this.dhlMapperService.getDhlDeliveryDate()).format('DD/MM/YYYY')
              }
            } else if (this.dhlMapperService.getDhlAddressType() === 'Shipping') {
              this.updateFormDhlMessage(false, 'Shipping');
              this.dhlResult[1] = {
                icon: 'fa fa-check',
                color: 'green',
                message: 'DHL_VALIDATION_OK_SHIPPING',
                extraData: moment(this.dhlMapperService.getDhlDeliveryDate()).format('DD/MM/YYYY')
              };
              if (this.dhlResult[0] && this.dhlResult[0].color !== 'red') {
                this.dhlResult[0] = {
                  icon: 'fa fa-check',
                  color: 'green',
                  message: 'DHL_VALIDATION_OK_WITHOUT_DATE',
                  extraData: ''
                }
              }
            }
          } else {
            this.dhlValidation = true;
            if (this.dhlMapperService.getDhlAddressType() === 'Site') {
              this.updateFormDhlMessage(true, 'Site');
              this.dhlResult[0] = {
                icon: 'fa fa-ban',
                color: 'red',
                message: 'DHL_VALIDATION_ERROR_SITE',
                extraData: this.dhlMapperService.getDhlMessageError()
              }
            } else if (this.dhlMapperService.getDhlAddressType() === 'Shipping') {
              this.updateFormDhlMessage(true, 'Shipping');
              this.dhlResult[1] = {
                icon: 'fa fa-ban',
                color: 'red',
                message: 'DHL_VALIDATION_ERROR_DELIVERY',
                extraData: this.dhlMapperService.getDhlMessageError()
              }
            }
          }
        }
      }
    });
    this.subscriptions.push(this.sub$);
  }

  updateAfterCountryChange(): void {
    this.timezoneObservable = this.timezone$.subscribe((value: Timezone[]) => {
      if (this.form) {
      //  this.showWarningTimeZone();
        this.updateTimeZoneInput(value);
      }
    });
    this.subscriptions.push(this.timezoneObservable);
    this.cultureObservable = this.cultures$.subscribe((value: Culture[]) => {
      if (this.form) {
        this.showWarningCulture();
        this.updateCultureInput(value);
      }
    });
    this.subscriptions.push(this.cultureObservable);
  }

  updateCultureInput(value: Culture[]): void {
    this.cultureList = value;
    const indexCulture = _.findIndex(value, function (o: Culture): boolean {
      return o.name === SEPARATOR_SELECT;
    });
    const ctrl = this.form.controls.addresses as FormArray;
    if (!this.form.get(['subscription', 'general' , 'cultures', 'code']).value && (indexCulture === 1) && ctrl.controls[0].get(['countryForm', 'name']).value) {
      this.form.get(['subscription', 'general', 'cultures']).patchValue(value[0]);
    }
  }

  updateTimeZoneInput(value: Timezone[]): void {
    const ctrl = this.form.controls.addresses as FormArray;
    this.timeZoneList = value;
    const indexTimezone = _.findIndex(value, function (o: Timezone): boolean {
      return o.name === SEPARATOR_SELECT;
    });
    if (this.form && !this.form.get(['site', 'ianaCode']).value && indexTimezone === 1 && ctrl.controls[0].get(['countryForm', 'name']).value) {
      this.form.get(['site', 'ianaCode']).patchValue(value[0].ianaCode);
     // this.form.get(['site', 'timezoneName']).patchValue(value[0].ianaCode);
    }
  }

  showWarningCulture(): void {
    if (this.form.get(['subscription', 'general', 'cultures', 'code']).value) {
      this.updateDynamicFormService.updateElement('cultures', true, 'warning');
    }
  }

  showWarningTimeZone(): void {
    if (this.form.get(['site', 'ianaCode']).value) {
      this.updateDynamicFormService.updateElement('timeZone', true, 'warning');
    }
  }
  updateWarningSSID(ssid: string): void {
    if (this.containsWhitespace(ssid[0]) || this.containsWhitespace(ssid[ssid.length - 1]) ) {
      this.updateDynamicFormService.updateElement('ssid', true, 'warning');
    } else if ((!this.containsWhitespace(ssid[0]) && !this.containsWhitespace(ssid[ssid.length - 1]))) {
      this.updateDynamicFormService.updateElement('ssid', false, 'warning');
    }
  }
  updateWarningPassword(password: string): void {
    this.updateDynamicFormService.updateElement('security_password', true, 'warning');
    if (this.containsWhitespace(password[0]) || this.containsWhitespace(password[password.length - 1]) ) {
      this.updateDynamicFormService.updateElement('security_password', true, 'warning');
    } else if (!this.containsWhitespace(password[0]) && !this.containsWhitespace(password[password.length - 1])) {
      this.updateDynamicFormService.updateElement('security_password', false, 'warning');
    }
  }
  containsWhitespace(str: string): boolean {
    return /\s/.test(str);
  }

  setValueChangesForm(): void {
    this.changeForDhlValidation();
    this.changeForCountryNameLoadTimezone();
    this.changeForTimezoneShowWarning();
    this.changeForCultureShowWarning();
    this.checkWifiValueChange();
    this.validityFormIfServer(this.form);
  }

  checkWifiValueChange(): void {
    this.sub$ = this.form.get(['subscription', 'network', 'wifi']).valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(200),
    ).subscribe(value => {
      if (value) {
        if (value.security_password) {
          this.updateWarningPassword(value.security_password);
        } else {
          this.updateDynamicFormService.updateElement('updateWarningPassword', false, 'warning');
        }
        if (value.ssid) {
             this.updateWarningSSID(value.ssid);
        } else {
           this.updateDynamicFormService.updateElement('ssid', false, 'warning');
        }
      }
    })
  }

  changeForDhlValidation(): void {
    // TODO: refcto generic function valuechanges
    const ctrl = this.form.controls.addresses as FormArray;
    this.sub$ = ctrl.controls[0].valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(value => {
      if (ctrl.controls[0].enabled && value) {
        this.updateFormDhlMessage(true, 'Site');
        this.dispatchValidationDhl(0); // TODO: commpentedt until updated
      }
    });
    this.subscriptions.push(this.sub$);
    // this.form.get(['misc', 'commentsForm', 'comments']).enable();
    this.sub$ = ctrl.controls[1].valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(value => {
      if (value.checkBox) {
        this.clearOneDhlMessage('Shipping');
      }
      if (ctrl.controls[1].enabled && !value.checkBox) {
        this.updateFormDhlMessage(true, 'Shipping');
        this.dispatchValidationDhl(1); // TODO: commpentedt until updated
      } else {
        this.updateDhlMessageShippingAddress();
      }
    });

    this.subscriptions.push(this.sub$);

    this.sub$ = this.form.get(['misc', 'expeditionForm', 'expeditionDate']).valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(200),
    ).subscribe(value => {
      const valueGeneral = this.form.getRawValue();
      if (this.form.get(['misc', 'expeditionForm']).enabled) {
        if (this.form.get(['misc', 'expeditionForm', 'expeditionDate']).dirty) {
          this.updateFormDhlMessage(true, 'dispatch');
          if (!valueGeneral.addresses[1].checkBox) {
            this.dispatchValidationDhl(1); // TODO: commpentedt until updated
          } else {
            this.dispatchValidationDhl(0); // TODO: commpentedt until updated
          }
        }
      }
    });
    this.subscriptions.push(this.sub$);
    this.sub$ = this.form.get(['misc', 'expeditionForm', 'expeditionDate']).valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(200),
    ).subscribe(value => {
      if (this.form.get(['misc', 'expeditionForm']).enabled) {
        this.updateFormDhlMessage(true, 'dispatch');
        this.dispatchValidationDhl(0); // TODO: commpentedt until updated
      }
    });
    this.subscriptions.push(this.sub$);
  }

  dispatchValidationDhl(occurence: number): void {
    const value = this.form.getRawValue();
    if (value.misc.expeditionForm.expeditionDate &&
      value.misc.expeditionForm.expeditionDate !== 'Invalid date' &&
      value.addresses[occurence].city &&
      value.addresses[occurence].zip &&
      value.addresses[occurence].countryForm.name) {
      if (occurence === 0) {
        this.store.dispatch(new ValidatedAddressDHLAction({
          'address': value.addresses[occurence],
          'expeditionDate': value.misc.expeditionForm.expeditionDate,
          'type': value.addresses[occurence].addressType
        }));
      }
      if (occurence === 1) {
        this.store.dispatch(new ValidatedAddressShippingDHLAction({
          'address': value.addresses[occurence],
          'expeditionDate': value.misc.expeditionForm.expeditionDate,
          'type': value.addresses[occurence].addressType
        }));
      }
    }
  }

  changeForCountryNameLoadTimezone(): void {
    const ctrl = this.form.controls.addresses as FormArray;
    this.sub$ = ctrl.controls[0].valueChanges.pipe(debounceTime(500)).subscribe(value => {
      if (value.countryForm && value.countryForm.name && value.countryForm.name !== ctrl.controls[0].get('country').value) {
        ctrl.controls[0].get('country').patchValue(value.countryForm.name); // due to in the mapper don't bind the country for addresses
        if (this.isAdd) {
          this.form.get(['site', 'ianaCode']).enable();
          this.form.get(['site', 'timezoneName']).enable();
        }
      }


      if (value.countryForm && value.countryForm.name && value.city && value.zip) {
        // this.store.dispatch(new ClearTimezonesSuccessAction());
        if (this.isAdd) {
          this.store.dispatch(new LoadTimezoneFullCultureAction(value));
        }
        this.showWarningTimeZone();
        const indexTimezone = _.findIndex(this.timeZoneList, function (o: Timezone): boolean {
          return o.name === SEPARATOR_SELECT;
        });
        for (let i = 0; i < indexTimezone; i++) {
          if (this.timeZoneList[i].ianaCode === this.form.get(['site', 'ianaCode']).value) {
            this.updateDynamicFormService.updateElement('timeZone', false, 'warning');
          }
        }
      }
    });
    this.subscriptions.push(this.sub$);

    this.sub$ = ctrl.controls[1].get(['countryForm', 'name']).valueChanges.pipe(debounceTime(500)).subscribe(value => {
      ctrl.controls[1].get('country').patchValue(value); // due to in the mapper don't bind the country for addresses
    });
    this.subscriptions.push(this.sub$);
  }

  changeForTimezoneShowWarning(): void {
    this.sub$ = this.form.get(['site', 'ianaCode']).valueChanges.pipe(
      skipWhile(value => _.isEmpty(value))
    ).subscribe(value => {
      this.showWarningTimeZone();
      const indexTimezone = _.findIndex(this.timeZoneList, function (o: Timezone): boolean {
        return o.name === SEPARATOR_SELECT;
      });
      for (let i = 0; i < indexTimezone; i++) {
        if (this.timeZoneList[i].ianaCode === value) {
          this.updateDynamicFormService.updateElement('timeZone', false, 'warning');
        }
      }
    });
    this.subscriptions.push(this.sub$);
  }

  changeForCultureShowWarning(): void {
    this.sub$ = this.form.get(['subscription', 'general', 'cultures', 'code']).valueChanges.pipe(
      skipWhile(value => _.isEmpty(value))
    ).subscribe(value => {
      this.showWarningCulture();
      const indexCulture = _.findIndex(this.cultureList, function (o: Culture): boolean {
        return o.name === SEPARATOR_SELECT;
      });
      for (let i = 0; i < indexCulture; i++) {
        if (this.cultureList[i].code === value) {
          this.updateDynamicFormService.updateElement('cultures', false, 'warning');
        }
      }
    });
    this.subscriptions.push(this.sub$);
  }

  validityFormIfServer(form: FormGroup): void {
    form.get(['subscription', 'base', 'serverForm' , 'url', 'id']).clearValidators();
    // form.get(['subscription', 'base', 'serverForm' , 'server', 'id']).clearValidators();
    form.get(['subscription', 'base', 'serverForm' , 'cms', 'id']).clearValidators();
    form.get(['subscription', 'base', 'serverForm' , 'cms',  'id']).updateValueAndValidity();
    form.get(['subscription', 'base', 'serverForm' , 'url',  'id']).updateValueAndValidity();
   // form.get(['subscription', 'base', 'serverForm' , 'server', 'id']).updateValueAndValidity();
    this.sub$ = this.store.pipe(
      select(fromRoot.selectors.getCMS),
      distinctUntilChanged(),
      skipWhile((server: ServerForm[]) => !server)
    ).subscribe(data => {
      if (!data.length) {
       // form.get(['subscription', 'base', 'serverForm', 'server', 'id']).clearValidators();
      //  form.get(['subscription', 'base', 'serverForm', 'server', 'id']).updateValueAndValidity();
        form.get(['subscription', 'base', 'serverForm', 'cms', 'id']).clearValidators();
        form.get(['subscription', 'base', 'serverForm', 'cms', 'id']).updateValueAndValidity();
      } else {
       // form.get(['subscription', 'base', 'serverForm', 'server', 'id']).setValidators([Validators.required]);
       // form.get(['subscription', 'base', 'serverForm', 'server', 'id']).updateValueAndValidity();
        form.get(['subscription', 'base', 'serverForm', 'cms', 'id']).setValidators([Validators.required]);
        form.get(['subscription', 'base', 'serverForm', 'cms', 'id']).updateValueAndValidity();
      }
    });
    this.subscriptions.push(this.sub$);
  }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean {
    let isDeactivable = true;
    this.viewChildren.forEach(formInstance => {
      if (formInstance.form.dirty) {
        isDeactivable = false;
      }
    });
    return isDeactivable;
  }

  save(renew: boolean, form: FormGroup): void {
    form.markAsPristine();
   // this.clearDhlMessage();
   // form.get(['subscription', 'base', 'name']).clearValidators();
   // form.get(['subscription', 'base', 'name']).updateValueAndValidity();
    form.get(['subscription', 'general' , 'name']).clearValidators();
    form.get(['subscription', 'general' , 'name']).updateValueAndValidity();
    this.store.dispatch(new AddOrdersAction({ renew: renew !== null ? renew : true, order: form.getRawValue() }));
    this.sub$ = this.dispatcher.pipe(
      debounceTime(100),
      filter(action => action.type === '[orders] Add Success')
    ).subscribe((data) => {
      if (renew === null) {
        this.store.dispatch(new LoadMySitesAction(this.form.get(['client', 'uuid']).value));
        this.resetFormDuplicate(this.form);
        this.clearWifiValidator();
        window.scroll(0, 0);
      }
      if (renew) {
        this.store.dispatch(new LoadMySitesAction(this.form.get(['client' , 'uuid']).value));
        this.resetFormRenew(this.form);
        this.clearWifiValidator();
        window.scroll(0, 0);
      }
    });
    this.subscriptions.push(this.sub$);
  }

  mapOrder(): void {
    this.sub$ = this.roles$.subscribe(roles => {
      let index;
      index = _.findIndex(roles, ['code', 'BO_INTERNAL_USER']);
      if (index !== -1) {
        this.isInternalUser = true;
      } else {
        this.isInternalUser = false;
      }
    })
    this.subscriptions.push(this.sub$);
    this.order$ = this.store.pipe(select(fromOrder.selectors.getOrder));
    this.sub$ = this.order$.pipe(
      skipWhile(o => o === null)
    ).subscribe((order: Order) => {
      if (order && !this.isAdd && !this.isAddSite) {
        this.store.dispatch(new UpdateBreadOrderDetailsAction());
        this.storeRoot.dispatch(new LoadCurrentClientAction(order.client.uuid));
        if (this.isEdit && (order.subscription.product.id === 24 || order.subscription.product.id === 27 || order.subscription.product.id === 28) ) {
          this.store.dispatch(new LoadConceptOrderAction(order.uuid));
        }
        if (order.subscription) {
          this.storeRoot.dispatch(new LoadProductionLineWithParamsAction({subscriptionUuid : order.subscription.uuid}));
        }

        this.patchForm(order);
        this.form.disable();
        this.form.get(['misc', 'commentsForm', 'comments']).reset(); // reset for not showing in patchMode
        this.patchArrayAddress(0, 'Site');
        this.patchArrayAddress(1, 'Shipping');
        this.enableIfExchange();
        this.isLoading = false;
      }
    });
    this.subscriptions.push(this.sub$);
    this.patchArrayAddress(0, 'Site');
    this.patchArrayAddress(1, 'Shipping');
  }
  mapConcepts(): void {
    this.concepts$ = this.store.pipe(select(fromOrder.selectors.getConceptsOrder));
    this.concepts$.subscribe(data => {
      const conceptsIds  = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          conceptsIds.push(data[i].conceptID)
        }
        this.form.get(['concepts', 'concepts', 'id']).patchValue(conceptsIds)
      }
    });
  }
  patchForm(order: Order): void {

    this.orderForm = this.orderMapper.dbToForm(order); // used to reset/undo in child
    this.form.patchValue(this.orderForm);
    this.form.get(['subscription' , 'general', 'cultures' , 'code']).patchValue(this.orderForm.subscription.general.cultures);
    this.form.get(['subscription' , 'general', 'name' ]).patchValue(this.orderForm.subscription.base.name);
    this.loadProduct();
  }

  loadProduct(): void {
    this.form.get(['subscription', 'base', 'productForm']).valueChanges.subscribe(val => {
      if (this.form.get(['subscription', 'base', 'productForm']).enabled) {
        if (this.orderForm.type !== 4) {
          // this.storeRoot.dispatch(new LoadProductsCompleteListClearAction());
          // this.storeRoot.dispatch(new LoadProductsAction());
        }
      }
    })
  }

  loadServer(): void {
    this.form.get(['subscription', 'base', 'serverForm', 'cms', 'id']).valueChanges.subscribe(val => {
      if (val) {
       // this.store.dispatch(new LoadServerByTypeAction(val));
      }
    })
  }
  patchArrayAddress(index: number, type: string): void {
    const arr = this.getArrayAddress(index);
    if (this.orderForm && this.orderForm.addresses[index]) {
      arr.patchValue(this.getAddressByType(type));
      arr.get(['countryForm', 'name']).patchValue(arr.get('country').value);
      arr.get('checkBox').patchValue(false); // deselect checkbox if has shipping address
    }
    arr.patchValue({ addressType: type });
  }

  // tslint:disable-next-line:no-any
  getAddressByType(type: string): any {
     let address;
     this.orderForm.addresses.forEach(addresse => {
       if (addresse && addresse.addressType.toLowerCase() === type.toLowerCase()) {
         address = addresse;
       }
     });
     return address;
  }
  enableIfExchange(): void {
    if (this.isExchange) {
      this.form.get(['misc', 'commentsForm', 'comments']).enable();
      this.form.get(['misc', 'expeditionForm', 'expeditionDate']).enable();
      this.form.get(['misc', 'expeditionForm', 'hasMaterial']).enable();
      this.form.get(['misc', 'expeditionForm', 'hasSetup']).enable();
      this.form.get(['productionLine', 'productionLine', 'name']).enable();
      this.form.get(['productionLine', 'productionLine', 'code']).enable();
      this.sub$ = this.productionLine$.pipe(
        skipWhile(o => o === null)
      ).subscribe((productionLine: ProductionLine[]) => {
        if (productionLine.length > 0) {
          this.form.get(['productionLine', 'productionLine', 'code']).patchValue(productionLine[0].code);
        }
      });
      this.subscriptions.push(this.sub$);
      this.form.clearAsyncValidators();
      this.form.clearValidators();
      this.form.updateValueAndValidity();
    }
  }

  bindClient(): void {
    if (this.isAdd) {
      this.form.get(['subscription', 'general' , 'name']).clearValidators();
      this.form.get(['subscription', 'general' , 'name']).updateValueAndValidity();
      this.form.get(['subscription', 'general' , 'name']).patchValue(' ');
    }

    this.sub$ = this.store.pipe(
      select(fromRoot.selectors.getCurrentClient),
      skipWhile((client: Client) => !client.name),
    ).subscribe((client: Client) => {
      const orderProduct  = this.form.get(['subscription', 'base', 'productForm' , 'product' , 'id']).value;
      if (orderProduct === 24  || orderProduct === 27 || orderProduct === 28) {
        this.storeRoot.dispatch(new LoadConceptsAction(client.uuid));
      }

      this.form.get('client').patchValue({ uuid: client.uuid });
      if (this.isAdd) {
        this.store.dispatch(new LoadMySitesAction(client.uuid));
        this.form.get(['site', 'name']).patchValue(client.name + ' - ');
        this.form.get('type').patchValue(2);
      }
      else if (this.isAddSite) {
        this.store.dispatch(new LoadMySitesAction(client.uuid));
        this.store.dispatch(new LoadSiteFullSummariesAction({
          clientUuid: client.uuid,
          siteUuid: this.activatedRoute.snapshot.paramMap.get('siteUuid')}));
        this.isLoading = false;
        this.store.pipe(select(fromShared.selectors.getMySites)).subscribe(data => {
          if (data) {
            for (let i = 0; i < data.length; ++i) {
              if (data[i].uuid === this.activatedRoute.snapshot.paramMap.get('siteUuid')) {
                this.form.get(['site', 'uuid']).patchValue(data[i].uuid);
                this.form.get(['site', 'name']).patchValue(data[i].name);
                this.form.get('type').patchValue(2);
               // this.form.get(['site', 'name']).clearValidators();
               // this.form.get(['site', 'name']).updateValueAndValidity();
                this.cdr.detectChanges();
              }
            }
          }
        });
      }
      this.store.dispatch(new LoadMyOrdersAction(client.name)); // TODO: mettre dans effect ?

    });
    this.subscriptions.push(this.sub$);
  }

  clearDhlMessage(): void {
    this.dhlResult = null;
    this.dhlValidation = null;
    this.dhlResult = [];
    // this.dhlResult = { icon: null, color: null, message: null, extraData: null };
  }
  resetFormRenew(form: FormGroup): void {
    if (!this.isExchange) {
      form.get(['misc']).reset();
      //  form.get(['productionLine']).reset();
      // form.get(['site']).reset();
      form.get(['site' , 'name']).reset();
      form.get(['site' , 'externalID']).reset();
      form.get(['subscription']).reset();
      form.get(['client']).reset();
      form.get(['misc', 'expeditionForm', 'expeditionDate']).patchValue( moment().add(7, 'days') );
    } else {
      form.get(['misc', 'expeditionForm', 'expeditionDate']).reset();
      form.get(['misc', 'commentsForm', 'comments']).reset();
    }
    this.bindClient();
    form.markAsPristine();
  }
  resetFormDuplicate(form: FormGroup): void {
    form.get(['misc', 'commentsForm', 'comments']).reset();
    if (!this.isExchange) {
      form.get(['subscription', 'general' , 'name']).setValidators([Validators.required]);
      form.get(['subscription', 'general' , 'name']).updateValueAndValidity();
      form.get(['subscription', 'general' , 'name']).reset();
    }
    form.markAsPristine();
    this.store.pipe(select(fromShared.selectors.getMySites)).subscribe(data => {
      if (data) {
        for (let i = 0; i < data.length; ++i) {
          if (data[i].name === this.form.get(['site', 'name']).value) {
            this.form.get(['site', 'uuid']).patchValue(data[i].uuid);
            this.form.get(['site', 'name']).patchValue(data[i].name);
            this.form.get('type').patchValue(2);
            this.cdr.detectChanges();
          }
        }
      }
    });
  }

  resetForm(form: FormGroup): void {
    if (!this.isExchange) {
      form.reset();
      this.formAddressesReset();
      form.get(['misc', 'expeditionForm', 'expeditionDate']).patchValue( moment().add(7, 'days') );
    } else {
      form.get(['misc', 'expeditionForm', 'expeditionDate']).reset();
      form.get(['misc', 'commentsForm', 'comments']).reset();
    }
    this.clearDhlMessage();
    this.bindClient();
    form.markAsPristine();
  }

  formAddressesReset(): void {
    this.getArrayAddress(0).get('addressType').patchValue('Site');
    this.getArrayAddress(1).get('addressType').patchValue('Shipping');
    this.getArrayAddress(1).get('checkBox').patchValue(true); // default checked

  }

  // TODO: transform into shared or order service for list and order detail
  getIconFromStatus(order: Order): { icon: string, text: string } {
    if (order) {
      switch (order.status) {
        case '1': {
          return { icon: 'fas fa-hdd', text: 'HAS_PLAYER' };
        }
        case '2': {
          return { icon: 'fas fa-cog', text: 'SET_UP' };
        }
        case '3': {
          return { icon: 'fas fa-flask', text: 'TEST_COMPLETED' };
        }
        case '4': {
          return { icon: 'fal fa-box-open', text: 'PACKED' };
        }
        case '5': {
          return { icon: 'fal fa-truck', text: 'PICKED_UP' };
        }
        case '6': {
          return { icon: 'fal fa-home', text: 'DELIVERED' };
        }
        case '7': {
          return { icon: 'fal fa-check', text: 'CLOSED' };
        }
        default: {
          break;
        }
      }
    }
    return null;
  }

  updateDhlMessageShippingAddress(): void {
    if (this.dhlMapperService.getDhlDeliveryDate() && this.dhlResult[0] && this.dhlResult[0].color !== 'red') {
      this.dhlResult[0] = {
        icon: 'fa fa-check',
        color: 'green',
        message: 'DHL_VALIDATION_OK_SITE',
        extraData: moment(this.dhlMapperService.getDhlDeliveryDate()).format('DD/MM/YYYY')
      };

      this.dhlResult[1] = { icon: null, color: null, message: null, extraData: null };
    }
  }

  disableShippingAddressIfSiteSame(): void {
    const arr = this.getArrayAddress(1);
    if (arr.get('checkBox').value === true) {
      this.resetOrDisableFormDataFromList('disable', arr, ['line1', 'line2', 'line3', 'zip', 'city', 'state', 'countryForm']);
    } else if (arr.get('checkBox').value === true) {
      arr.enable()
    }
  }

  clearWifiValidator(): void {
    this.form.get(['subscription', 'network', 'wifi', 'ssid']).clearValidators();
    this.form.get(['subscription', 'network', 'wifi', 'ssid']).updateValueAndValidity();
    this.form.get(['subscription', 'network', 'wifi', 'security_password']).clearValidators();
    this.form.get(['subscription', 'network', 'wifi', 'security_password']).updateValueAndValidity();
    this.form.get(['subscription', 'network', 'wifi', 'eap_password']).clearValidators();
    this.form.get(['subscription', 'network', 'wifi', 'eap_password']).updateValueAndValidity();
    this.form.get(['subscription', 'network', 'wifi', 'eap_identity']).clearValidators();
    this.form.get(['subscription', 'network', 'wifi', 'eap_identity']).updateValueAndValidity();
  }

  updateFormDhlMessage(error: boolean, type: string): void {
    if (this.form) {
      const ctrl = this.form.controls.addresses as FormArray;
      if (type === 'Shipping') {
        if (!error) {
          ctrl.controls[1].setErrors(null);
        } else {
          ctrl.controls[1].setErrors({ required: true });
        }

      } else if (type === 'Site') {
        if (!error) {
          ctrl.controls[0].setErrors(null);
        } else {
          ctrl.controls[0].setErrors({ required: true });
        }

      } else if (type === 'dispatch') {
        if (!error) {
          this.form.get(['misc', 'expeditionForm']).setErrors(null);
        } else {
          this.form.get(['misc', 'expeditionForm']).setErrors({ required: true });
        }
      }
    }
  }

  resetOrDisableFormDataFromList(action: string, form: FormGroup, path: string[]): void {
    path.forEach(field => {
      const control = form.get(field);
      if (action === 'reset') {
        control.reset();
      } else if (action === 'disable') {
        control.disable()
      }
    });
  }

  getArrayAddress(index: number): FormGroup {
    const res = this.form.get('addresses') as FormArray;
    return res.controls[index] as FormGroup;
  }

  clearOneDhlMessage(type: string): void {
    if (type === 'Shipping') {
      this.dhlResult[1] = null;
    } else if (type === 'Site') {
      this.dhlResult[0] = null;
    }
  }

  cancel(): void {
    this.location.back();
  }
  cancelOrderPopup(): void {
    this.cancelOrder.open();
  }
  resetPopup(): void {
    this.resetOrder.open();
  }
}

